module.exports = __webpack_public_path__ + "img/2013.10.1f4fa8df.png";